export const MOBILE_SCREEN = 414;
export const TABLET_SCREEN = 769;
export const DESKTOP_SCREEN = 1024;
